 const lang = {
    login: {
      HEADER: "Please login",
    },
  };
  
  export default lang;